import React from "react";
import PropTypes from "prop-types";
import { FormLabel } from "@mui/material";

import TextInput from "../../../ui/TextInput";
import { ADJUSTMENT_FACTORS } from "../../../constants/intxConstants";

export default function VolumeAdjustmentFactorFields({
  defaultValues,
  errors,
  register,
}) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", marginTop: "40px" }}>
      {[
        {
          title: "Adjustment Factors",
          fields: [
            {
              label: "U-Turn Adjustment Factor",
              name: "utaf",
              suggestedValue: ADJUSTMENT_FACTORS.UTAF,
            },
            {
              label: "Left Turn Adjustment Factor",
              name: "ltaf",
              suggestedValue: ADJUSTMENT_FACTORS.LTAF,
            },
            {
              label: "Right Turn Adjustment Factor",
              name: "rtaf",
              suggestedValue: ADJUSTMENT_FACTORS.RTAF,
            },
          ],
        },
        {
          title: "Truck Factors",
          fields: [
            {
              label: "Truck PCE Factor",
              name: "truckPCE",
              suggestedValue: ADJUSTMENT_FACTORS.TRUCK_PCE,
            },
          ],
        },
        {
          title: "CLV Sum Limit",
          fields: [
            {
              label: "2-Phase Signal",
              name: "twoPhaseCLVSumLimit",
              suggestedValue: ADJUSTMENT_FACTORS.TWO_PHASE_SIGNAL_CLV_SUM_LIMIT,
            },
            {
              label: "3-Phase Signal",
              name: "threePhaseCLVSumLimit",
              suggestedValue:
                ADJUSTMENT_FACTORS.THREE_PHASE_SIGNAL_CLV_SUM_LIMIT,
            },
            {
              label: "4-Phase Signal",
              name: "fourPhaseCLVSumLimit",
              suggestedValue:
                ADJUSTMENT_FACTORS.FOUR_PHASE_SIGNAL_CLV_SUM_LIMIT,
            },
          ],
        },
      ].map(({ fields, title }) => {
        return (
          <div
            key={title}
            style={{ marginBottom: "40px", marginRight: "40px" }}
          >
            <FormLabel>{title}</FormLabel>
            {fields.map(({ label, name, suggestedValue }) => (
              <div
                key={name}
                style={{ marginTop: "20px", suggestedValue: 1700 }}
              >
                <TextInput
                  defaultValue={defaultValues[name] ?? suggestedValue}
                  label={label}
                  errors={errors}
                  isRequired
                  register={register}
                  name={name}
                  type="number"
                />
              </div>
            ))}
          </div>
        );
      })}
    </div>
  );
}

VolumeAdjustmentFactorFields.propTypes = {
  defaultValues: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
};
